import React, { useEffect, useState } from 'react';
import RangeSlider from './RangeSlider';
import { Radio } from './../../components/forms/input';
import { Input } from '../../components/forms/input';
import Thanks from '../../components/Thanks';
import axios from 'axios';
const DesignCalculator = props => {
  const [showDesign, setShowDesign] = useState(props.show);
  const [showThanks, setShowThanks] = useState(false);
  const [loadedThanks, setLoadedThanks] = useState(false);
  const [responsive, setResponsive] = useState('');
  const [numberOfePages, setNumberOfPages] = useState(0);
  const [copywritingOfePages, setCopywritingOfPages] = useState(0);
  const [databaseIndex, setDatabaseIndex] = useState(0);
  const [ecommerce, setEcommerce] = useState(0);
  const [cms, setCms] = useState(0);
  const numbers = ['I   don’t know', '1-10', '11-20', '21-50', '50+'];
  const copy = ['I   don’t know', '1-10', '11-20', '21-50', '50+'];
  const database = ['None', 'Basic', 'Advanced ', 'Full Development'];
  const eccomerce = ['None', 'Basic', 'Advanced ', 'Enterprise'];
  const cmsTexts = ['None', 'Basic', 'Advanced ', 'Enterprise'];
  useEffect(() => {
    setShowDesign(props.show);
  }, [props.show]);
  const getTrackStyle = val => {
    setResponsive(val);
  };
  const handleChange = () => {};
  const hide = () => {
    document.getElementById('calculate-form').reset();
    setNumberOfPages(0);
    setCopywritingOfPages(0);
    setDatabaseIndex(0);
    setEcommerce(0);
    setCms(0);
    props.hide();
  };
  const changeIndex = (type, index) => {
    switch (type) {
      case 'pagesElementSWlider':
        setNumberOfPages(index);
        break;
      case 'CopywritingOfPages':
        setCopywritingOfPages(index);
        break;
      case 'databaseIntegration':
        setDatabaseIndex(index);
        break;
      case 'ecommerce':
        setEcommerce(index);
        break;
      case 'cms':
        setCms(index);
        break;
    }
  };
  const hideThanksModal = () => {
    setShowThanks(false);
    setLoadedThanks(false);
    document.body.style.overflow = 'auto';
    document.body.style.overflowX = 'hidden';
    hide();
  };
  const onSubmit = e => {
    e.preventDefault();
    const formEntries = new FormData(e.target).entries();
    const json = Object.assign(...Array.from(formEntries, ([x, y]) => ({ [x]: y })));
    var form_data = new FormData(e.target);
    for (let key in json) {
      form_data.append(key, json[key]);
    }
    form_data.append('country', props.country);
    form_data.append('title', 'Web Design Price');
    form_data.append('number-of-pages', numbers[numberOfePages]);
    form_data.append('copywriting', copy[copywritingOfePages]);
    form_data.append('responsive-design', responsive);
    form_data.append('database-integratuion', database[databaseIndex]);
    form_data.append('Ecommerce', eccomerce[ecommerce]);
    form_data.append('cms', cmsTexts[cms]);
    // setShowThanks(true)
    document.body.style.overflow = 'hidden';
    axios.post('https://mailer.weprodigi.com/api/v1/proposal-design', form_data).then(response => {
      // setLoadedThanks(true)
      window.location.href = 'https://weprodigi.com/thank-you';
    });
    // e.target.reset()
  };
  return (
    <>
      <div
        className={
          'fixed overflow-y-auto 	 z-900 bg-navbar w-full h-full left-0 top-0 right-0 bottom-0 items-center justify-center' +
          ' ' +
          (showDesign && !showThanks ? 'flex' : 'hidden')
        }
      >
        <div className="absolute left-0 top-0 w-full h-full" onClick={() => hide()} />
        <div className="relative    transform w-11/12 max-w-screen-md max-h-screen-md  bg-gray border border-gray-transparent rounded-5 md:scale-60 2xl:scale-100">
          <form className="overflow-y-auto h-design-calculator  " id="calculate-form" method="POST" onSubmit={e => onSubmit(e)}>
            <div
              className="absolute -right-12 -top-12 bg-purple text-white w-30 h-30 text-21 rounded-full flex items-center justify-center cursor-pointer select-none"
              onClick={() => hide()}
            >
              <span className="font-bold">X</span>
            </div>
            <div className="py-23 px-30 md:px-50 min-h-300">
              <p className="text-purple uppercase text-30 text-center font-black  ">Web Design Calculator</p>
              <p className="font-bolder text-18 leading-20 text-purple mt-30">Tell us about your web design needs</p>
              <div className="mt-10 md:mt-50 flex flex-wrap items-center  ">
                <div className="w-full md:w-40p  text-16 text-black">Number of pages</div>
                <div className="w-full mt-40 md:mt-0 md:w-60p">
                  <RangeSlider
                    name="pagesElementSWlider"
                    activetIndex={numberOfePages}
                    items={[
                      {
                        displayName: 'I don’t know',
                        value: 0,
                        image: 'url(/images/design/dontknow.png)',
                      },
                      { displayName: '10-10', value: 10, image: 'url(/images/design/1-10.png)' },
                      { displayName: '11-20', value: 20, image: 'url(/images/design/11-20.png)' },
                      { displayName: '21-50', value: 30, image: 'url(/images/design/21-50.png)' },
                      { displayName: ' 50++ ', value: 40, image: 'url(/images/design/50+.png)' },
                    ]}
                    change={changeIndex}
                  />
                </div>
              </div>
              <div className="mt-10 md:mt-40 flex flex-wrap items-center">
                <div className="w-full md:w-40p  text-16 text-black">Copywriting of pages</div>
                <div className="w-full mt-40 md:mt-0 md:w-60p">
                  <RangeSlider
                    name="CopywritingOfPages"
                    activetIndex={copywritingOfePages}
                    items={[
                      {
                        displayName: 'I don’t know',
                        value: 0,
                        image: 'url(/images/design/dontknow.png)',
                      },
                      { displayName: '10-10', value: 10, image: 'url(/images/design/1-10.png)' },
                      { displayName: '11-20', value: 20, image: 'url(/images/design/11-20.png)' },
                      { displayName: '21-50', value: 30, image: 'url(/images/design/21-50.png)' },
                      { displayName: '50++', value: 40, image: 'url(/images/design/50+.png)' },
                    ]}
                    change={changeIndex}
                  />
                </div>
              </div>
              <div className="mt-10 md:mt-10 flex flex-wrap items-center">
                <div className="w-full md:w-40p  text-16 mt-40 text-black">Responsive Design</div>
                <div className="w-full flex mt-10 md:mt-30 md:w-60p">
                  <Radio className="mr-30" name="responsive" value="Yes" onChange={() => getTrackStyle('yes')}>
                    Yes
                  </Radio>
                  <Radio name="responsive" value="No" onChange={() => getTrackStyle('no')}>
                    No
                  </Radio>
                </div>
              </div>
              <div className="mt-10 md:mt-40 flex flex-wrap items-center">
                <div className="w-full md:w-40p  text-16 text-black">Database Integration</div>
                <div className="w-full mt-40 md:mt-0 md:w-60p">
                  <RangeSlider
                    name="databaseIntegration"
                    activetIndex={databaseIndex}
                    items={[
                      { displayName: 'None', value: 0, image: 'url(/images/design/none.png)' },
                      { displayName: 'Basic', value: 10, image: 'url(/images/design/basic.png)' },
                      {
                        displayName: 'Advanced ',
                        value: 20,
                        image: 'url(/images/design/advanced.png)',
                      },
                      {
                        displayName: 'Full Developent',
                        value: 30,
                        image: 'url(/images/design/fulldevelopement.png)',
                      },
                    ]}
                    change={changeIndex}
                  />
                </div>
              </div>
              <div className="mt-10 md:mt-40 flex flex-wrap items-center">
                <div className="w-full md:w-40p  text-16 text-black">Ecommerce Functionality</div>
                <div className="w-full mt-40 md:mt-0 md:w-60p">
                  <RangeSlider
                    name={'ecommerce'}
                    activetIndex={ecommerce}
                    items={[
                      { displayName: 'None', value: 0, image: 'url(/images/design/none.png)' },
                      { displayName: 'Basic', value: 10, image: 'url(/images/design/basic.png)' },
                      {
                        displayName: 'Advanced ',
                        value: 20,
                        image: 'url(/images/design/advanced.png)',
                      },
                      {
                        displayName: 'Enterpris',
                        value: 30,
                        image: 'url(/images/design/enterprice.png)',
                      },
                    ]}
                    change={changeIndex}
                  />
                </div>
              </div>
              <div className="mt-10 md:mt-40 flex flex-wrap items-center">
                <div className="w-full md:w-40p  text-16 text-black">CMS</div>
                <div className="w-full mt-40 md:mt-0 md:w-60p">
                  <RangeSlider
                    name="cms"
                    activetIndex={cms}
                    items={[
                      { displayName: 'None', value: 0, image: 'url(/images/design/none.png)' },
                      { displayName: 'Basic', value: 10, image: 'url(/images/design/basic.png)' },
                      {
                        displayName: 'Advanced ',
                        value: 20,
                        image: 'url(/images/design/advanced.png)',
                      },
                      {
                        displayName: 'Enterpris',
                        value: 30,
                        image: 'url(/images/design/enterprice.png)',
                      },
                    ]}
                    change={changeIndex}
                  />
                </div>
              </div>
              <p className="font-bolder text-18 leading-20 text-purple mt-30">Tell us how to contact you</p>
              <div className="mb-10">
                <p className="text-14 text-black mb-5 mt-30">Name*</p>
                <div className="mb-10">
                  <Input type="text" name="name" bg="bg-gray-light" required={true} onChange={handleChange} />
                </div>
                <div className="grid grid-cols-2 gap-10">
                  <div>
                    <p className="text-14 text-black mb-5">Email*</p>
                    <div className="mb-10">
                      <Input type="text" name="email" bg="bg-gray-light" required={true} onChange={handleChange} />
                    </div>
                  </div>
                  <div>
                    <p className="text-14 text-black mb-5">Number</p>
                    <div className="mb-10">
                      <Input type="text" name="number" bg="bg-gray-light" required={false} onChange={handleChange} />
                    </div>
                  </div>
                </div>
                <p className="text-14 text-black mb-5">What’s the best way to contact you?</p>
                <div className="flex flex-row my-10">
                  <div className="form-group mr-30">
                    <label className="relative pl-30 cursor-pointer text-14 flex items-center">
                      <input
                        className="absolute cursor-pointer opacity-0"
                        onChange={() => handleChange('contact-via', 'Email')}
                        type="radio"
                        name="contact-via"
                        value="Email"
                      />
                      <span className="checkmark absolute left-0 w-20 h-20 border border-purple rounded-sm" />
                      Email
                    </label>
                  </div>
                  <div className="form-group mr-30">
                    <label className="relative pl-30 cursor-pointer text-14 flex items-center">
                      <input
                        className="absolute cursor-pointer opacity-0"
                        onChange={() => handleChange('contact-via', 'Phone')}
                        type="radio"
                        name="contact-via"
                        value="Phone"
                      />
                      <span className="checkmark absolute left-0 w-20 h-20 border border-purple rounded-sm" />
                      Phone
                    </label>
                  </div>
                  <div className="form-group mr-30">
                    <label className="relative pl-30 cursor-pointer text-14 flex items-center">
                      <input
                        className="absolute cursor-pointer opacity-0"
                        onChange={() => handleChange('contact-via', 'Both')}
                        type="radio"
                        name="contact-via"
                        value="Both"
                      />
                      <span className="checkmark absolute left-0 w-20 h-20 border border-purple rounded-sm" />
                      Both
                    </label>
                  </div>
                </div>
                <p className="text-14 text-black mb-5">Send NDA</p>
                <div className="flex flex-row my-10">
                  <div className="form-group mr-30">
                    <label className="relative pl-30 cursor-pointer text-14 flex items-center">
                      <input
                        className="absolute cursor-pointer opacity-0"
                        onChange={() => this.handleChange('nda', 'Yes')}
                        type="radio"
                        name="nda"
                        value="Yes"
                      />
                      <span className="checkmark absolute left-0 w-20 h-20 border border-purple rounded-sm" />
                      Yes
                    </label>
                  </div>
                  <div className="form-group mr-30">
                    <label className="relative pl-30 cursor-pointer text-14 flex items-center">
                      <input
                        className="absolute cursor-pointer opacity-0"
                        onChange={() => this.handleChange('nda', 'No')}
                        type="radio"
                        name="nda"
                        value="No"
                      />
                      <span className="checkmark absolute left-0 w-20 h-20 border border-purple rounded-sm" />
                      No
                    </label>
                  </div>
                </div>
              </div>
              <div className="mt-10 md:mt-40 flex flex-wrap justify-center items-center">
                <button type="" className="quote-submit cursor-pointer text-white bg-green text-18 px-23 py-3 rounded-5">
                  {' '}
                  Request Price
                </button>
              </div>
            </div>
          </form>
        </div>
      </div>
      <Thanks show={showThanks} loaded={loadedThanks} hide={hideThanksModal}>
        Thank you for reaching out to us! One of our account managers will contact you and confirm your request. If you don’t receive an email from us
        within 24 hours please check your Spam Box.
      </Thanks>
    </>
  );
};
export default DesignCalculator;
